<template>
  <b-container
    fluid
    class="about-us-section text-white"
    ref="counterSection"
  >
    <b-row class="text-center py-5">

      <!-- Happy Clients -->
      <b-col md="3" sm="6" class="mb-4">
        <b-card class="bg-transparent border-0">
          <b-icon icon="people-fill" variant="light" font-scale="3"></b-icon>
          <h2 class="mt-3">{{ counters.clients }}+</h2>
          <p>Happy Clients</p>
        </b-card>
      </b-col>

      <!-- Projects -->
      <b-col md="3" sm="6" class="mb-4">
        <b-card class="bg-transparent border-0">
          <b-icon icon="briefcase-fill" variant="light" font-scale="3"></b-icon>
          <h2 class="mt-3">{{ counters.projects }}+</h2>
          <p>Completed Projects</p>
        </b-card>
      </b-col>

      <!-- Awards -->
      <b-col md="3" sm="6" class="mb-4">
        <b-card class="bg-transparent border-0">
          <b-icon icon="trophy-fill" variant="light" font-scale="3"></b-icon>
          <h2 class="mt-3">{{ counters.awards }}</h2>
          <p>Awards Won</p>
        </b-card>
      </b-col>

      <!-- Experience -->
      <b-col md="3" sm="6" class="mb-4">
        <b-card class="bg-transparent border-0">
          <b-icon icon="calendar-check-fill" variant="light" font-scale="3"></b-icon>
          <h2 class="mt-3">{{ counters.years }}+</h2>
          <p>Years Experience</p>
        </b-card>
      </b-col>

    </b-row>
  </b-container>
</template>




<script>
export default {
  name: "AboutCounters",
  data() {
    return {
      counters: {
        clients: 0,
        projects: 0,
        awards: 0,
        years: 0
      },
      targets: {
        clients: 60,
        projects: 120,
        awards: 50,
        years: 10
      },
      hasCounted: false
    };
  },
  mounted() {
    this.observeSection();
  },
  methods: {
    observeSection() {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !this.hasCounted) {
            this.startCounters();
            this.hasCounted = true;
            observer.disconnect();
          }
        },
        { threshold: 0.3 }
      );

      observer.observe(this.$refs.counterSection);
    },

    startCounters() {
      Object.keys(this.counters).forEach((key) => {
        const interval = setInterval(() => {
          if (this.counters[key] < this.targets[key]) {
            this.counters[key]++;
          } else {
            clearInterval(interval);
          }
        }, 25);
      });
    }
  }
};
</script>


<style scoped>
  .about-us-section {
  background-image: url('../assets/carousel_2.jpg'); /* Replace with actual path */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

</style>